import { Model } from '@vuex-orm/core';
import LatestColorAPI from '@/modules/ColorModule/api/controllers/LatestColorAPI';

export default class Color extends Model {
    public static entity = 'color';

    public static fields() {
        return {
            id: this.attr(''),
            name: this.attr(''),
        };
    }

    public static async getAll(query: string = '') {
        let colors: any = [];

        // If a query is provided, fetch data directly (no caching for now)
        try {
            colors = await LatestColorAPI.getAll();
            return Promise.resolve(colors.data);
        } catch (error) {
            console.error('Error fetching data with query:', error);
            return Promise.reject(error);
        }
    }

    public static async createNew(data: any) {
        let colors;

        try {
            colors = await LatestColorAPI.createNew(data);
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(colors.data);
    }

    public id!: string;
    public name!: string;
}
